export const getUi2ApiErrorListName = (listName: string): string => {
    return listName === 'networks' ? 'salesRateListEntry' : listName;
};
